import React, { Component } from 'react';
import './index.scss';
import Loader from '../../pages/loader';
import * as API from '../../configuration/apiconfig';
import Keyboard from 'react-simple-keyboard';
import 'react-simple-keyboard/build/css/index.css';
import { keyboardLayout } from '../../utils/keyBoardLayout';
import { Modal, Form } from 'react-bootstrap';
import { ReactComponent as CloseIcon } from '../../assets/images/closeIcon.svg';
import KeypadIcon from '../../assets/images/keypad.png';
import { ReactComponent as MobileIcon } from '../../assets/images/mobile-icon.svg';
import { ReactComponent as KeyboardIcon } from '../../assets/images/keyboard-icon.svg';
import PhoneIcon from "../../assets/images/mobile-icon-small.png"


const buttonTheme = [
  {
    class: 'phone-login-close-button',
    buttons: '{phoneLoginCloseButton}',
  },
  {
    class: 'backspace-button',
    buttons: '{bksp}',
  },
];

export default class PhoneNumberLogin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loader: false,
      layoutName: 'ip',
      loginErrorMsg: '',
      phoneNumber: '',
      showKeyboard: false,
    };
  }

  // keyBoardOnChangePhone = input => {
  //   alert('1');
  //   if (this.props.activeInput === 'phone') {
  //     this.setState({ phoneNumber: input });
  //   }
  // };

  keyBoardOnKeyPress = button => {
    // console.log("Button pressed", button);
    if (button === '{shift}' || button === '{lock}') this.keyBoardHandleShift();

    if (button === '{phoneLoginCloseButton}') {
      this.setState({
        showKeyboard: false,
        phoneNumber: '',
        loginErrorMsg: '',
      });
      this.props.phoneNumberChange('');
    }
  };

  keyBoardHandleShift = () => {
    const layoutName = this.state.layoutName;
    this.setState({
      layoutName: layoutName === 'default' ? 'shift' : 'default',
    });
  };

  clickKeyboardIconPhone = () => {
    this.setState(
      {
        showKeyboard: !this.state.showKeyboard ? true : false,
      },
      () => {
        var getInputElem = document.getElementById('phoneNumberInput');
        if (getInputElem) {
          document.getElementById('phoneNumberInput').focus();
        }
      }
    );
  };

  setKeyboard = () => {
    this.setState({
      showKeyboard: true,
    });
  };

  openKeyboard = () => {
    this.setState({ showKeyboard: true });
  };

  closeKeyboard = () => {
    this.setState({ showKeyboard: false });
  };

  phoneNumberChange = phoneNumber => {
    this.props.phoneNumberChange(phoneNumber);
  };

  openPhoneLoginModal = () => {
    this.setState({ showKeyboard: true });
    this.props.updateParentState({ showPhoneLoginModal: true });
  };

  closePhoneLoginModal = () => {
    this.setState({ showKeyboard: false });
    this.props.updateParentState({ showPhoneLoginModal: false, phoneNumber: '', loginErrorMsg: '' });
  };

  render() {
    return (
      <React.Fragment>
        <Loader loader={this.state.loader} />
        <div className={`phone-number-login ${this.props.dynamicComponent ? 'dynamic-component-login' : ''}`}>
          <div className="scan-btn">
            <button
              className="btn-phone-login btn btnPrimary"
              onClick={this.openPhoneLoginModal}
            >
              <MobileIcon />
              SIGN IN VIA MOBILE NUMBER
            </button>
          </div>
        </div>

        {/* Phone Login Modal */}
        <Modal show={this.props.showPhoneLoginModal} dialogClassName="phone-login-modal" centered onHide={this.closePhoneLoginModal}>
          <Modal.Header>
            <button className="modal-close-button" onClick={this.closePhoneLoginModal}>
              <CloseIcon />
            </button>
          </Modal.Header>
          <Modal.Body>
            <div className="content">
              <div className="keypad-image">
                <img src={KeypadIcon} alt="Keypad" />
              </div>
              <p className="title">Enter your Registered Mobile Number</p>
              <div className="input-wrap">
                <input
                  onFocus={() => {
                    this.props.setLoginType('phone');
                    this.props.toggleKeyboard('phone');
                  }}
                  ref={input => {
                    this.textInput = input;
                  }}
                  id="phoneNumberInput"
                  type="text"
                  placeholder="Enter Mobile Number"
                  autoComplete="off"
                  value={this.props.phoneNumber}
                  readOnly
                />
                <button className="keyboard-icon" onClick={this.clickKeyboardIconPhone}>
                  <KeyboardIcon />
                </button>
              </div>
              {this.props.phoneNumber != '' && this.props.loginErrorMsg != '' && (
                <div className="error-blk">
                  <p>{this.props.loginErrorMsg}</p>
                </div>
              )}
              <button
                className="btn btnPrimary"
                disabled={this.props?.disableContinueBtn()}
                onClick={() => this.props.handlePhoneNumberLogin()}
              >
                SUBMIT
              </button>
            </div>
            {this.state.showKeyboard ? (
              <Keyboard
                keyboardRef={r => (this.keyboard = r)}
                layoutName={'ip'}
                onChange={input => this.phoneNumberChange(input)}
                onKeyPress={this.keyBoardOnKeyPress}
                layout={keyboardLayout}
                display={{
                  '{bksp}': 'Backspace',
                  '{phoneLoginCloseButton}': 'Close',
                }}
                disableRowButtonContainers={true}
                baseClass={'login-barcodescan-keyboard'}
                maxLength={10}
                buttonTheme={buttonTheme}
              />
            ) : null}
          </Modal.Body>
        </Modal>

        {/* User Selection Modal */}
        {
          this.props.canHaveMultipleUsers &&
          <Modal show={this.props.showUsersChoiceModal} dialogClassName="user-selection-modal" centered onHide={() => this.props.updateParentState({ showUsersChoiceModal: false })}>
            <Modal.Header>
              <button className="modal-close-button" onClick={() => this.props.updateParentState({ showUsersChoiceModal: false, showKeyboard: false, phoneNumber: '', loginErrorMsg: '' })}>
                <CloseIcon />
              </button>
            </Modal.Header>
            <Modal.Body>
              <div className="content">
                <h4 className="title">
                  Select Loyalty Account
                </h4>
                <div className="mobile-number-details">
                  <span>
                    Accounts linked to
                  </span>
                  <span className="mobile-number-pill">
                    <img src={PhoneIcon} alt="" />
                    {this.props.phoneNumber}
                  </span>
                </div>
                <p className='desc1'>Looks like this phone number is linked to multiple loyalty accounts.</p>
                <p className="desc2">Please select an account to continue.</p>
                <Form className='users-choice-form' onChange={(e) => this.props.updateParentState({ selectedUserAccount: e.target.value })}>
                  {
                    this.props.usersList.length > 0 && this.props.usersList.map((user, userIndex) => {
                      return (
                        <Form.Check
                          type={'radio'}
                          id={user.cardNumber ? user.cardNumber : userIndex}
                          value={user.cardNumber}
                          checked={this.props.selectedUserAccount === user.cardNumber}
                          className={this.props.selectedUserAccount === user.cardNumber ? "is-selected" : ""}
                          label={<><span className='name'>{user.firstname + " " + user.lastname}</span>
                            <span className='email'>{user.email}</span></>}
                        />
                      )
                    })
                  }
                </Form>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <div className="ok-btn">
                <a href="javascript:;" className="btn btnPrimary" title="OK"
                  disabled={this.props.selectedUserAccount.length < 1 || this.props.loader === true}
                  onClick={() => this.props.loginMemberCard()}>
                  CONTINUE
                </a>
              </div>
            </Modal.Footer>
          </Modal>
        }
      </React.Fragment>
    );
  }
}
